// src/index.js (or src/main.jsx depending on your setup)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { UserProvider } from './contexts/UserContext';
import { CartProvider } from './contexts/CartContext';
import { SearchProvider } from './contexts/SearchContext';
import { LessonsProvider } from './contexts/LessonsContext';
import { AvailabilityProvider } from './contexts/AvailabilityContext';
import { MessagesProvider } from './contexts/MessagesContext';
import { DocumentsProvider } from './contexts/DocumentsContext';
import { TeachersApprovalProvider } from './contexts/TeachersApprovalContext';
import { AdminDashboardProvider } from './contexts/AdminDashboardContext';
import { SupplierProgramsProvider } from './contexts/SupplierProgramsContext';
import { SupplierDashboardProvider } from './contexts/SupplierDashboardContext';
import { SchoolProgramsProvider } from './contexts/SchoolProgramsContext';
import { GpnBudgetPurchasesProvider } from './contexts/GpnBudgetPurchasesContext';
import { CouponRedemptionProvider } from './contexts/CouponRedemptionContext';



const InnerProviders = () => {
  const appTree = (
    
      <SearchProvider>
        <LessonsProvider>
          <CartProvider>
            <AvailabilityProvider>
              <MessagesProvider>
                <TeachersApprovalProvider>
                  <DocumentsProvider>
                    <AdminDashboardProvider>
                      <SupplierProgramsProvider>
                        <SupplierDashboardProvider>
                          <SchoolProgramsProvider>
                            <GpnBudgetPurchasesProvider>
                              <CouponRedemptionProvider>
                                <App />
                              </CouponRedemptionProvider>
                            </GpnBudgetPurchasesProvider>
                          </SchoolProgramsProvider>
                        </SupplierDashboardProvider>
                      </SupplierProgramsProvider>
                    </AdminDashboardProvider>
                  </DocumentsProvider>
                </TeachersApprovalProvider>
              </MessagesProvider>
            </AvailabilityProvider>
          </CartProvider>
        </LessonsProvider>
      </SearchProvider>
   
  );

  return appTree;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* UserProvider must wrap InnerProviders so useUser() can read userType */}
    <UserProvider>
      <InnerProviders />
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();